export const HERO_BENTO_MODULE_TABLET_BREAKPOINT = 768; // Custom tablet breakpoint
export const HERO_BENTO_CARD_DESKTOP_WIDTH = 646;
export const HERO_BENTO_CARD_TABLET_WIDTH = 273;
export const HERO_BENTO_CARD_MOBILE_WIDTH = 228;

// LOHP fast follow hero changes
export const HERO_BENTO_CARD_DESKTOP_WIDTH_OPTIMIZATION = 892;
export const HERO_BENTO_CARD_MOBILE_WIDTH_OPTIMIZATION = 326;
